import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes (similar to your current cache duration)
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Data will be garbage collected after 30 minutes of inactivity
      gcTime: 1000 * 60 * 30, // 30 minutes (previously called cacheTime)
      // Retry failed requests up to 2 times
      retry: (failureCount, error: any) => {
        // Don't retry on client errors (4xx)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Don't retry on authentication errors
        if (
          error?.message?.includes("401") ||
          error?.message?.includes("403")
        ) {
          return false;
        }
        return failureCount < 2;
      },
      // Refetch on window focus (can be disabled if too aggressive)
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect by default (your app might handle this differently)
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry mutations once on network errors
      retry: (failureCount, error: any) => {
        // Don't retry client errors
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});
